import React, { Component } from 'react'
import { connect } from 'react-redux'
import querystring from 'query-string'
import classnames from 'classnames'
import 'whatwg-fetch'
import autobind from 'autobind-decorator';

import EntryItemAllCheckbox from "../../common/EntryItemAllCheckbox";
import { parseListParams } from '../../common/EntryListHelper';

import { selectAllItems, deselectAllItems, updateSelectedItems, receiveItems} from '../../../actions/contents/page';
import TSelectFilter from "../../common/TSelectFilter";
import EntryHeaderStatusChangeButton from "../EntryHeaderStatusChangeButton"
import EntryHeaderSearchButton from "../EntryHeaderSearchButton"

@connect(state => ({
  items: state.page.item.items,
  searchKeyword: state.page.condition.searchKeyword,
  searchType: state.page.condition.searchType,
}), dispatch => ({
  handleSelectAllItems: () => {
    dispatch(selectAllItems())
  },
  handleDeselectAllItems: () => {
    dispatch(deselectAllItems())
  },
  handleUpdateSelectedItems: (values) => {
    dispatch(updateSelectedItems(values))
  },
  handleReceiveItems: (items, totalCount) => {
    dispatch(receiveItems(items, totalCount))
  },
  dispatch
}))
class PageListHeader extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      optionOpen: false,
      searchOpen: false,
      processing: false,
      deleting: false,
      searching: false,
      searchKeyword : '',
      searchType: 'title',
      searchTypeOptions : [{ label : '제목', value: 'title'}, { label : '내용', value: 'content'}]
    };

    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleOpenSearch = this.handleOpenSearch.bind(this);
    this.handleCloseSearch = this.handleCloseSearch.bind(this);
    this.searchUpdated = this.searchUpdated.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { searchKeyword, searchType } = this.state;
    const nextSearchKeyword = nextProps.searchKeyword;
    const nextSearchType = nextProps.searchType;
    if(nextSearchKeyword === '' || (searchKeyword === nextSearchKeyword && searchType === nextSearchType)){
      this.setState({
        searching: false,
      });
    }
  }

  handleSelectAll(e) {
    const { handleSelectAllItems, handleDeselectAllItems } = this.props
    if (e.target.checked) {
      handleSelectAllItems()
    } else {
      handleDeselectAllItems()
    }
  }

  @autobind
  handleChangeOpenOption(open) {
    this.setState({
      optionOpen: open
    })
  }

  handleOpenSearch(e) {
    this.setState({
      searchOpen: true,
      searchKeyword:'',
      searchType: 'title',
    });
  }

  handleCloseSearch(e) {
    this.setState({
      searchOpen: false
    })
  }

  handleSearch() {

    const { searchKeyword, searchType}  = this.state;

    let history = this.props.history;
    let location = this.props.location;

    if (searchKeyword.length > 0) {

      let listParams = parseListParams(location.search);
      if(listParams.searchKeyword !== searchKeyword || listParams.searchType !== searchType){
        history.push(location.pathname + "?" + querystring.stringify({searchKeyword: searchKeyword, searchType : searchType}));
        this.setState({
          searching: true,
        });
      }
    }
    this.handleCloseSearch();
  }

  searchUpdated (value) {
    this.setState({searchKeyword: value})
  }

  @autobind
  selectSearchType(item, idx) {

    this.setState({
      searchType: item.value
    })
  }

  render() {

    const { optionOpen, searchOpen, searchKeyword, searching, searchTypeOptions, searchType  } = this.state;
    const { items } = this.props;

    if(searching) {
      return (<div className="wrap_search loading_search">
        <TSelectFilter className={"filter_search"} items={searchTypeOptions} disabled={true}
                       selected={searchType}
                       onSelect={(item, idx) => this.selectSearchType(item, idx)}/>
        <em className="txt_keyword">{searchKeyword}</em>
        <span className="txt_change">
                        검색중
                        <span className="ico_blog ico_change"/>
                    </span>
      </div>);
    }

    return (
      <div className={classnames({
        "wrap_search": true,
        "on": searchOpen
      })}>
        <EntryItemAllCheckbox
          items={items}
          handleSelectAll={this.handleSelectAll}
        />

        <EntryHeaderSearchButton
          searchOpen={searchOpen}
          searchKeyword={searchKeyword}
          searchType={searchType}
          searchTypeOptions={searchTypeOptions}
          onChangeSearchType={this.selectSearchType}
          onChangeKeyword={this.searchUpdated}
          onOpen={this.handleOpenSearch}
          onClose={this.handleCloseSearch}
          onSearch={this.handleSearch}
          placeholder={"페이지 관리에서 검색합니다."}
        />

        <EntryHeaderStatusChangeButton
          type={'pages'}
          items={items}
          optionOpen={optionOpen}
          onChangeOpen={this.handleChangeOpenOption}
        />
      </div>
    )
  }
}

export default PageListHeader;
